import {Component, ViewChild} from '@angular/core';

import {BoiteDialogueLogComponent} from '../../../../../val-ammon-composants/val-traitements-lib/src/public-api';
import {DonneesSelectionComplementComptable, SelectionComplementComptableDialogueComponent} from "./selection-complement-comptable-dialogue.component";
import {ValApiResultat} from '../../../../../val-ammon-services/val-services-communs-lib/src/public-api';
import {AeFRapprocherComplementComptableBt30Parametres, AeFRechercherComplementsComptableBt30Parametres, AeFRechercherComplementsComptableBt30Resultat, EFactTraitementService} from '../../../../../val-ammon-services/val-services-efact-lib/src/public-api';

//Gère le traitement de recherche des compléments comptable BT-30
@Component (
{
  selector: 'val-rechercher-complement-comptable-bt30',
  imports: 
  [
    BoiteDialogueLogComponent,
    SelectionComplementComptableDialogueComponent
  ],
  templateUrl: './rechercher-complement-comptable-bt30.component.html',
  styleUrl: './rechercher-complement-comptable-bt30.component.scss',
})
export class RechercherComplementComptableBt30Component 
{
  //Création
  //  Paramètres
  //    eFactTraitementService: Service e-Facture
  constructor (private eFactTraitementService: EFactTraitementService) 
  {
  }

  //Boîte de dialogue log
  @ViewChild ("boiteDialogueLog")
  public boiteDialogueLog!: BoiteDialogueLogComponent;

  //Boîte de dialogue de sélection d’un complément comptable
  @ViewChild ("boiteDialogueSelectionComplementComptable")
  public boiteDialogueSelectionComplementComptable!: SelectionComplementComptableDialogueComponent;

  //Exécute le traitement
  //  Paramètres
  //    identifiantsFactures : Identifiants des factures
  public async Executer (identifiantsFactures: string[]) : Promise<void> 
  {
    let operation: Promise<void>;
    let aefRechercherComplementsComptableBt30Parametres: AeFRechercherComplementsComptableBt30Parametres;
    let valApiResultat: ValApiResultat<AeFRechercherComplementsComptableBt30Resultat>;
    let donneesSelectionComplementComptable: DonneesSelectionComplementComptable;
    let aefRapprocherComplementComptableBt30Parametres: AeFRapprocherComplementComptableBt30Parametres;

    operation = new Promise<void> (async (fonctionRetour) =>
    {
      aefRechercherComplementsComptableBt30Parametres = new AeFRechercherComplementsComptableBt30Parametres ();
      aefRechercherComplementsComptableBt30Parametres.identifiantSession = crypto.randomUUID ();
      aefRechercherComplementsComptableBt30Parametres.identifiantsFactures = identifiantsFactures;

      this.boiteDialogueLog.Executer (aefRechercherComplementsComptableBt30Parametres.identifiantSession);

      valApiResultat = await this.eFactTraitementService.RechercherComplementsComptableBt30 (aefRechercherComplementsComptableBt30Parametres);

      await this.boiteDialogueLog.AttendreFermeture ();

      if (valApiResultat.status === "success")
      {
        if (valApiResultat.resultat!.selectionManuelle)
        {
          this.boiteDialogueSelectionComplementComptable.donnees.numeroFacture = valApiResultat.resultat!.numeroFacture;
          this.boiteDialogueSelectionComplementComptable.donnees.complementsComptable = valApiResultat.resultat!.complementsComptable;

          donneesSelectionComplementComptable = await this.boiteDialogueSelectionComplementComptable.Ouvrir ();

          if (donneesSelectionComplementComptable.valide)
          {
            aefRapprocherComplementComptableBt30Parametres = new AeFRapprocherComplementComptableBt30Parametres ();
            aefRapprocherComplementComptableBt30Parametres.identifiantSession = crypto.randomUUID ();
            aefRapprocherComplementComptableBt30Parametres.identifiantFacture = identifiantsFactures[0];
            aefRapprocherComplementComptableBt30Parametres.identifiantComplementComptable = donneesSelectionComplementComptable.identifiant;
            aefRapprocherComplementComptableBt30Parametres.numeroFacture = donneesSelectionComplementComptable.numeroFacture;

            this.boiteDialogueLog.Executer (aefRapprocherComplementComptableBt30Parametres.identifiantSession);

            await this.eFactTraitementService.RapprocherComplementComptableBt30 (aefRapprocherComplementComptableBt30Parametres);

            await this.boiteDialogueLog.AttendreFermeture ();
          }
        }
      }

      fonctionRetour ();
    });

    return operation;
  }
}
